<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-app-bar dark color="primary">
            <v-toolbar-title>{{ $t("auth.change_password") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-form ref="form">
              <v-flex xs12>
                <v-text-field
                  data-vv-name="current_password"
                  prepend-icon="lock"
                  v-model="current_password"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('auth.current_password')"
                  :error-messages="errors.collect('current_password')"
                  type="password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-name="new_password"
                  prepend-icon="lock"
                  v-model="new_password"
                  class="required-field"
                  v-validate="'required|password_strength'"
                  :label="$t('auth.new_password')"
                  :error-messages="errors.collect('new_password')"
                  type="password"
                  ref="new_password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-name="new_password_retype"
                  data-vv-as="new_password"
                  prepend-icon="lock"
                  v-model="new_password_retype"
                  class="required-field"
                  v-validate="'required|confirmed:new_password|password_strength'"
                  :label="$t('auth.new_password_retype')"
                  :error-messages="errors.collect('new_password_retype')"
                  type="password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <action-button type="default" :text="$t('auth.update_password')" @click="update" :icon_only_xs="false"/>
            <action-button type="default" color="error" :text="$t('auth.logout')" @click="logout" :icon_only_xs="false"/>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios"
export default {
  name: "updatepassword",

  props: ["locale"],

  data() {
    return {
      user: {},
      current_password: "",
      new_password: "",
      new_password_retype: "",
      dictionary: {
        attributes: {
          current_password: this.$t("auth.current_password"),
          new_password: this.$t("auth.new_password"),
          new_password_retype: this.$t("auth.new_password_retype")
        }
      }
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let vm = this
    this.user = this.$store.getters["auth/user"]

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale
  },

  methods: {
    update() {
      let vm = this

      this.$validator.validate()

      this.$validator.validateAll().then(() => {
        if (this.isFormValid) {
          axios
            .post(this.API_URL + "auth/password/update", {
              id: vm.user.id,
              current_password: vm.current_password,
              new_password: vm.new_password
            })
            .then((res) => {
              if (res) {
                vm.$router.push(this.BACKEND_URL + "/dashboard")
              } else {
                vm.$awn.alert(vm.$t("auth.update_password_error"))
              }
            })
            .catch((error) => {
              if (error.response.status == 411) {
                vm.$awn.alert(vm.$t("auth.password_does_not_match_error"))
              }
            })
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },

    logout() {
      this.$clearCookies()
      this.$store.dispatch("settings/reset", this)
      this.$store.dispatch("auth/logout", this)
    }
  }
}
</script>
